'use client'

import styles from './Breadcrumb.module.css';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';

interface BreadcrumbProps {
    titulo: string;
    color?: string;
    showSpan?: boolean;
    showBackButton?: boolean;
    chamada?: string;
    chamadaColor?: string;
    useH4?: boolean; // NOVA PROP
    useH2?: boolean;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
    titulo,
    color,
    showSpan = true,
    showBackButton = true,
    chamada,
    chamadaColor,
    useH4 = false,
    useH2 = false // VALOR PADRÃO = false, ou seja, usa <h1>
}) => {
    const pathname = usePathname();
    const [extraClass, setExtraClass] = useState('');

    useEffect(() => {
    if (pathname === '/EuQuero/SolicitarBVA') {
        setExtraClass(styles.voltarAssinar);
    } else if (
        pathname === '/Produtos/Corporativo' ||
        pathname === '/Produtos/EnsinoTecnico' ||
        pathname === '/Produtos/EnsinoSuperior'
    ) {
        setExtraClass(styles.BreadcrumbProdutos);
    } else {
        setExtraClass('');
    }
}, [pathname]);

    return (
        <section className={`${styles.breadCrumb} ${extraClass}`}>
            <div className={styles.uiContainer}>
                {showBackButton && (
                    <button
                        aria-label="Botão voltar para a página anterior"
                        onClick={() => window.history.back()}
                        className={`${styles.btnVoltar} ${extraClass}`}
                    >
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.94531 18.0156C9.78906 18.2109 9.47656 18.2109 9.28125 18.0156L1.11719 9.85156C0.921875 9.65625 0.921875 9.38281 1.11719 9.1875L9.28125 1.02344C9.47656 0.828125 9.78906 0.828125 9.94531 1.02344L10.7266 1.76562C10.9219 1.96094 10.9219 2.27344 10.7266 2.42969L4.67188 8.48438H18.0312C18.2656 8.48438 18.5 8.71875 18.5 8.95312V10.0469C18.5 10.3203 18.2656 10.5156 18.0312 10.5156H4.67188L10.7266 16.6094C10.9219 16.7656 10.9219 17.0781 10.7266 17.2734L9.94531 18.0156Z" fill="#1C5DB1"/>
                        </svg>
                        Voltar
                    </button>
                )}
                <div className={styles.dFlex}>
                    {chamada && <p className={`${styles.chamadaArea} ${chamadaColor}`}>{chamada}</p>}

                    {useH4 ? (
                        <h4 tabIndex={0} className={styles.TituloAreaH4}>
                            {titulo}
                            {showSpan && <span className={color}>.</span>}
                        </h4>
                    ) : useH2 ? (
                        <h2 tabIndex={0} className={styles.TituloAreaH2}>
                            {titulo}
                            {showSpan && <span className={color}>.</span>}
                        </h2>
                    ) : (
                        <h1 tabIndex={0} className={styles.TituloArea}>
                            {titulo}
                            {showSpan && <span className={color}>.</span>}
                        </h1>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Breadcrumb;